import { render } from "./update.vue?vue&type=template&id=8098c5b4&scoped=true"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"

import "./update.vue?vue&type=style&index=0&id=8098c5b4&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8098c5b4"]])

export default __exports__